import React, { useState, useEffect } from 'react';
import './PWAUpdatePrompt.css';

const PWAUpdatePrompt: React.FC = () => {
  const [showUpdatePrompt, setShowUpdatePrompt] = useState(false);
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        setRegistration(reg as ServiceWorkerRegistration);

        // Verificar atualizações periodicamente (a cada hora)
        setInterval(() => {
          reg.update();
        }, 60 * 60 * 1000);

        // Detectar quando há um novo service worker esperando
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Há uma nova versão disponível
                setShowUpdatePrompt(true);
              }
            });
          }
        });
      });

      // Detectar quando o service worker foi atualizado
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          // Recarregar a página quando o novo service worker assumir controle
          window.location.reload();
        }
      });
    }
  }, []);

  const handleUpdate = async () => {
    if (registration?.waiting) {
      // Enviar mensagem para o service worker para pular a espera
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      setShowUpdatePrompt(false);
      // Recarregar a página
      window.location.reload();
    } else if (registration) {
      // Tentar atualizar manualmente
      await registration.update();
      setShowUpdatePrompt(false);
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    setShowUpdatePrompt(false);
  };

  if (!showUpdatePrompt) {
    return null;
  }

  return (
    <div className="pwa-update-prompt">
      <div className="pwa-update-content">
        <div className="pwa-update-icon">🔄</div>
        <div className="pwa-update-text">
          <h3>Nova versão disponível!</h3>
          <p>Uma atualização do aplicativo está disponível. Deseja atualizar agora?</p>
        </div>
        <div className="pwa-update-buttons">
          <button onClick={handleUpdate} className="pwa-update-button primary">
            Atualizar Agora
          </button>
          <button onClick={handleDismiss} className="pwa-update-button secondary">
            Depois
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAUpdatePrompt;

